import { ICloudStorageAccess } from "./cloudstorage/cloudStorageAccess";
import { LocalFileAccess } from "./cloudstorage/local";
import { FirebaseAccess } from "./cloudstorage/firebase";
import TagSelectorWidget from "./components/tag-selector";
import Controller from "./controller";
import { TagID } from "./entities/tagid";

const env = process.env.NODE_ENV;
const prefix = window.location.host.split(".")[0];

let repository: ICloudStorageAccess =
  env === "development" ? new LocalFileAccess() : new FirebaseAccess(prefix);
const controller = new Controller(
  document.getElementById("canvas-container"),
  repository,
);

import version from "./version";
console.log(`App version: ${version}`);
document.getElementById("logo")!.innerText += ` v${version}`;

// 最初にどのタグをロードするかを判定する
//
// 1. URLのクエリパラメータでの指定
// 2. ローカルストレージでの指定 (TODO: Implement)
const tag = new URLSearchParams(window.location.search).get("tag");
let tagSelected = false;
if (tag) {
  controller.init(new TagID(tag));
  tagSelected = true;
}

// タグ選択ウィジェットを初期化
// 前段の処理で初期化されたタグがあれば、それを選択状態にする
const tagSelectorWidget = new TagSelectorWidget(
  document.getElementById("select-tag-widget-container"),
  repository,
);

tagSelectorWidget.onSelect = (t: TagID) => controller.init(t);
tagSelectorWidget.render();
